import { useQuery } from "@apollo/client";
import "./SchoolPolicies.css";
import { POLICIES } from "../../api";
import { CreatePolicy, UpdatePolicy, DeletePolicy } from "../../components";
import moment from "moment";

export default function SchoolPolicies({ setModal }) {
  const { loading, error, data } = useQuery(POLICIES);

  if (error) {
    console.log(error);
    return <div>Error</div>;
  }

  if (loading || !data) {
    return <div>Loading</div>;
  }

  const policies = data.policies;

  return (
    <div className="Page">
      <div className="Page__header">
        <div className="Page__header__title">School Policies</div>

        <div className="Page__header__options">
          {/* <div className="Page__header__options__search">
            <div className="Page__header__options__search__icon"></div>

            <input className="Page__header__options__search__input" />
          </div> */}

          <div
            className="Page__header__options__button"
            onClick={() => {
              setModal(
                <CreatePolicy
                  setModal={setModal}
                  update={(cache, { data: { createPolicy } }) => {
                    const q = cache.readQuery({
                      query: POLICIES,
                    });

                    cache.writeQuery({
                      query: POLICIES,
                      data: {
                        policies: [...q.policies, createPolicy],
                      },
                    });

                    setModal(false);
                  }}
                />
              );
            }}
          >
            Add Policy
          </div>
        </div>
      </div>

      <div className="Page__body">
        <div className="Page__table">
          <div className="Page__table__header">
            <div className="Page__table__row">
              <div className="Page__table__row__data" style={{ width: "30%" }}>
                Name
              </div>

              <div className="Page__table__row__data" style={{ width: "30%" }}>
                Url
              </div>

              <div className="Page__table__row__data" style={{ width: "15%" }}>
                Updated at
              </div>

              <div className="Page__table__row__data" style={{ width: "10%" }}>
                Show in footer?
              </div>
              <div
                className="Page__table__row__data"
                style={{ width: "15%" }}
              ></div>
            </div>
          </div>

          <div className="Page__table__body">
            {policies.map((p) => (
              <div className="Page__table__row">
                <div
                  className="Page__table__row__data"
                  style={{ width: "30%" }}
                >
                  {p.name}
                </div>

                <div
                  className="Page__table__row__data"
                  style={{ width: "30%" }}
                >
                  {p.url}
                </div>
                <div
                  className="Page__table__row__data"
                  style={{ width: "15%" }}
                >
                  {moment(p.updatedAt).fromNow()}
                </div>
                <div
                  className="Page__table__row__data"
                  style={{ width: "10%" }}
                >
                  {p.showInFooter ? "Yes" : "-"}
                </div>
                <div
                  className="Page__table__row__data"
                  style={{ width: "15%" }}
                >
                  <div
                    className="Page__table__row__data__option"
                    onClick={() => {
                      setModal(
                        <UpdatePolicy
                          policy={p}
                          setModal={setModal}
                          update={(cache, { data: { updatePolicy } }) => {
                            cache.modify({
                              id: cache.identify(p),
                              fields: {
                                name() {
                                  return updatePolicy.name;
                                },
                                url() {
                                  return updatePolicy.url;
                                },
                              },
                            });

                            setModal(false);
                          }}
                        />
                      );
                    }}
                  >
                    Edit
                  </div>

                  <div
                    className="Page__table__row__data__option"
                    onClick={() => {
                      setModal(
                        <DeletePolicy
                          policy={p}
                          setModal={setModal}
                          update={(cache, { data: { deletePolicy } }) => {
                            const q = cache.readQuery({
                              query: POLICIES,
                            });

                            cache.writeQuery({
                              query: POLICIES,
                              data: {
                                policies: [...q.policies].filter(
                                  (x) => x.id !== deletePolicy.id
                                ),
                              },
                            });

                            setModal(false);
                          }}
                        />
                      );
                    }}
                  >
                    Delete
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
